import { createFrontendModule } from '@backstage/frontend-plugin-api';
import toolboxPlugin from '@drodil/backstage-plugin-toolbox/alpha';

const toolboxPage = toolboxPlugin.getExtension('page:toolbox').override({
  params: { noHeader: true },
});

export const toolboxPageModule = createFrontendModule({
  pluginId: 'toolbox',
  extensions: [toolboxPage],
});
